import { render, staticRenderFns } from "./PageParksConfig.vue?vue&type=template&id=ff932ba8&scoped=true"
import script from "./PageParksConfig.vue?vue&type=script&lang=ts"
export * from "./PageParksConfig.vue?vue&type=script&lang=ts"
import style0 from "./PageParksConfig.vue?vue&type=style&index=0&id=ff932ba8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff932ba8",
  null
  
)

export default component.exports